import accordionScript from "./blocks/accordion";
import boxSliderScript from "./blocks/boxSlider";
import boxSliderGridScript from "./blocks/boxSliderGrid";
import headerScript from "./blocks/header";
import zigZagScript from "./blocks/zigZag";
import "./blocks/animations";

function onReady() {
  accordionScript();
  boxSliderScript();
  boxSliderGridScript();
  headerScript();
  zigZagScript();
}

if (document.readyState !== "loading") {
  onReady();
} else {
  document.addEventListener("DOMContentLoaded", onReady);
}
